import EthereumNetwork from '@providers/EthereumNetwork'
import PolygonNetwork from '@providers/PolygonNetwork'
import { IAbiItem } from '@types'

export const handleGetContractName = (
    provider: EthereumNetwork | PolygonNetwork,
    contractAbi: IAbiItem[],
    contractAddress: string,
) => {
    return provider.getWeb3Contract(contractAbi, contractAddress).methods.name().call()
}
